// src/pages/Chat/ContactPickerModal.jsx
import React, { useState, useEffect } from "react";
import { FiX, FiSearch, FiUser, FiSend } from "react-icons/fi";
import apiClient from "../../api/apiClient";

export default function ContactPickerModal({ onClose, onSelect }) {
  const [query, setQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const { data } = await apiClient.get("/accounts/api/users/", { params: { all_for_chat: "true" } });
        const list = Array.isArray(data) ? data : (data.users || data.results || []);
        setUsers(list);
      } catch (err) {
        console.error("Failed to fetch users:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const filtered = users.filter(u => 
    u.full_name?.toLowerCase().includes(query.toLowerCase()) ||
    u.employee_id?.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <>
      <div className="fixed inset-0 z-[110] bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="fixed z-[111] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-sm">
        <div className="bg-slate-900 border border-white/10 rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[70vh]">
          <div className="flex items-center justify-between px-4 py-3 border-b border-white/8">
            <span className="text-sm font-semibold text-slate-100">Share Contact</span>
            <button onClick={onClose} className="p-1.5 rounded-lg text-slate-500 hover:text-slate-300 transition-colors">
              <FiX size={16} />
            </button>
          </div>

          <div className="p-3 border-b border-white/8">
            <div className="relative">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" size={14} />
              <input
                autoFocus
                type="text"
                placeholder="Search contacts..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="w-full pl-9 pr-3 py-2 rounded-xl text-xs bg-white/5 border border-white/10 text-slate-200 placeholder-slate-600 outline-none focus:border-blue-500/50 transition-all"
              />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-1">
            {loading && <div className="p-4 text-center text-xs text-slate-500">Loading contacts...</div>}
            {filtered.map(user => (
              <button
                key={user.employee_id}
                onClick={() => onSelect(user)}
                className="w-full flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-white/5 transition-colors text-left"
              >
                <div className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center text-xs font-bold text-blue-400">
                  {user.full_name?.split(" ").map(n=>n[0]).join("").toUpperCase() || <FiUser />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-slate-200 truncate">{user.full_name}</p>
                  <p className="text-[10px] text-slate-500 truncate">{user.employee_id} • {user.department}</p>
                </div>
                <FiSend className="text-slate-600 group-hover:text-blue-400" size={14} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
